import client from "./client";

export default {

    async getPenalties(filters) {
        return client.parseResponse(await client.get('/penalties', filters));
    },
    async getPenaltyPayments(filters) {
        return client.parseResponse(await client.get('/penalty-payments', filters));
    },
    async getPenalty(id) {
        return client.parseResponse(await client.get('/penalties/' + id));
    },
    async createPenalty(data) {
        return client.parseResponse(await client.post('/penalties', data))
    },
    async editPenalty(data) {
        return client.parseResponse(await client.put('/penalties/' + data.id, data))
    },
    async deletePenalty(data) {
        return client.parseResponse(await client.delete('/penalties/' + data.id, data))
    }
}
